import BoxContainer from "./BoxContainer";
import Box from "@material-ui/core/Box";
import BoxHeading from "./BoxHeading";
import { Trans } from "react-i18next";
import Button from "@material-ui/core/Button";
import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import useRoutes, { getLinkComponentAttributes } from "../../hooks/useRoutes";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useTheme from "@material-ui/core/styles/useTheme";
import { useAuth } from "../../providers/AuthProvider";

const useStyles = makeStyles((theme) => ({
  bottomContainer: {
    marginTop: theme.spacing(4),
  },
  button: {
    minWidth: "136px",
    paddingRight: 0,
    paddingLeft: 0,
    [theme.breakpoints.down("xs")]: {
      minWidth: "96px",
    },
  },
  heading: {
    fontSize: "20px",
    color: theme.palette.primary.dark + " !important",
    margin: 0,
  },
  loggedInText: {
    textAlign: "center",
  },
}));

const UserLoggedInBox = () => {
  const classes = useStyles();
  const routes = useRoutes();
  const theme = useTheme();
  const isXS = useMediaQuery(theme.breakpoints.down("xs"));
  const { user } = useAuth();

  const myAccountProps = getLinkComponentAttributes(
    "products.packages",
    routes
  );

  return (
    <BoxContainer className={classes.bottomContainer}>
      <Box display="flex" alignItems="center">
        <Box className={classes.loggedInText} flexGrow={1}>
          <BoxHeading className={classes.heading}>
            <Trans>Logged in</Trans>
          </BoxHeading>
          <div>{user.name}</div>
        </Box>
        <Button
          variant="contained"
          color="primary"
          size={"large"}
          classes={{ root: classes.button }}
          {...myAccountProps}
        >
          <Trans>My picture sets</Trans>
        </Button>
      </Box>
    </BoxContainer>
  );
};

export default UserLoggedInBox;
